var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWarningCircle = function SvgWarningCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 15 15",
    fill: "#DFA400",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.406a6.094 6.094 0 1 0 0 12.188 6.094 6.094 0 0 0 0-12.188Zm-.469 3.282a.469.469 0 0 1 .938 0v3.28a.469.469 0 1 1-.938 0v-3.28ZM7.5 10.78a.704.704 0 1 1 0-1.407.704.704 0 0 1 0 1.407Z"
  })));
};

export default SvgWarningCircle;